/* ==========================================================================
   product-details-lower.js
   Behaviour for snippets/product-details-lower.liquid:
   story carousel, frequently-bought-together bundle, description clamp.
   Self-contained IIFE — safe to load with or without the upper module.
   ========================================================================== */
(function () {
  'use strict';

  function formatMoney(cents, template) {
    if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents);
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    // Reuse the currency wrapper rendered by Liquid (e.g. "Dhs. 1.00 AED") when available.
    if (template) return template.replace(/[\d.,]+/, amount);
    return amount;
  }

  function initCarousel(root) {
    var carousel = root.querySelector('[data-pdl-carousel]');
    if (!carousel) return;
    var track = carousel.querySelector('[data-pdl-track]');
    var prev = carousel.querySelector('[data-pdl-prev]');
    var next = carousel.querySelector('[data-pdl-next]');
    var bar = carousel.querySelector('[data-pdl-progress]');

    function step() {
      var slide = track.querySelector('.pdl__slide');
      return slide ? slide.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      var ratio = track.clientWidth / track.scrollWidth;
      if (bar) {
        bar.style.width = Math.max(ratio * 100, 10) + '%';
        bar.style.marginLeft = (max > 0 ? (track.scrollLeft / max) * (100 - Math.max(ratio * 100, 10)) : 0) + '%';
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function initFbt(root) {
    var fbt = root.querySelector('[data-pdl-fbt]');
    if (!fbt) return;
    var inputs = Array.prototype.slice.call(fbt.querySelectorAll('input[type="checkbox"]'));
    var totalEl = fbt.querySelector('[data-pdl-fbt-total]');
    var formatEl = fbt.querySelector('[data-pdl-fbt-format]');
    var template = formatEl ? formatEl.textContent.trim() : '';
    var addBtn = fbt.querySelector('[data-pdl-fbt-add]');

    function recalc() {
      var total = inputs.reduce(function (sum, i) {
        return i.checked ? sum + (parseInt(i.dataset.price, 10) || 0) : sum;
      }, 0);
      if (totalEl) totalEl.textContent = formatMoney(total, template);
    }

    inputs.forEach(function (i) { i.addEventListener('change', recalc); });
    recalc();

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = inputs
          .filter(function (i) { return i.checked; })
          .map(function (i) { return { id: Number(i.value), quantity: 1 }; });
        if (!items.length) return;

        addBtn.disabled = true;
        var original = addBtn.textContent;
        addBtn.textContent = window.kefitT('pdl_adding', 'ADDING…');

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            addBtn.textContent = window.kefitT('pdl_added', 'ADDED ✓');
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 1600);
          })
          .catch(function () {
            addBtn.textContent = window.kefitT('pdl_try_again', 'TRY AGAIN');
            addBtn.disabled = false;
          });
      });
    }
  }

  function initClamp(root) {
    var body = root.querySelector('[data-pdl-clamp]');
    var toggle = root.querySelector('[data-pdl-clamp-toggle]');
    if (!body || !toggle) return;
    if (body.scrollHeight <= body.clientHeight + 8) { toggle.hidden = true; return; }
    toggle.addEventListener('click', function () {
      var open = body.classList.toggle('is-open');
      toggle.textContent = open ? window.kefitT('pdl_read_less', 'READ LESS') : window.kefitT('pdl_read_more', 'READ MORE');
    });
  }

  function initLower(root) {
    if (!root || root.dataset.pdlInit === 'true') return;
    root.dataset.pdlInit = 'true';
    initCarousel(root);
    initFbt(root);
    initClamp(root);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-pdl]').forEach(initLower);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
